import { getQSVar, getTotalAddOnsPrice, applyDiscount } from '../utils';
import { IAddOn, IGlassesPackage } from '../types';

export function getPricingDetails(
    selectedPackage: IGlassesPackage,
    addOns: IAddOn[] | undefined
) {
    const framePrice = Number(getQSVar('price')) || 0;
    const { priceInt, discountPercentage } = selectedPackage;
    const hasDiscount = !!discountPercentage && discountPercentage > 0;
    const glassesPrice = hasDiscount
        ? applyDiscount(priceInt, discountPercentage)
        : priceInt;
    const rawAddOnsPrice = addOns ? getTotalAddOnsPrice(addOns) : 0;
    const addOnsPrice = hasDiscount
        ? applyDiscount(rawAddOnsPrice, discountPercentage)
        : rawAddOnsPrice;
    const subTotal = framePrice + glassesPrice + addOnsPrice;
    const discount = 0;
    const total = subTotal - discount;

    return {
        framePrice,
        glassesPrice,
        discount,
        subTotal,
        total,
    };
}
